<template>
  <div class="finance-view">
    <div class="picker-container">
      <financePicker @click="transferDate"></financePicker>
    </div>
    <financeTab :tabItem="tabItem" @click="handelClick" ref="childTab">
      <div class="loading-wrap" v-show="isLoading">
    		<i></i>
    		<span>加载中...</span>
    	</div>
      <ul :class="['ul-container',(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)&&(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)&&(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3?'nodata-container':'']" v-show="activedIndex==0">
        <li class="li-container" v-if="getItemLen(XGFXARR.GGData)>0">
          <p class="title title-purple">港股新股</p>
          <ul class="sub-ul ggxg">
            <li v-if="XGFXARR.GGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in XGFXARR.GGData">
              <p class="sub-title">{{i.type=='1'?"认购中：":"今日上市："}}</p>
              <ul>
                <li v-for="(item,index) in getTenData(XGFXARR.GGData[j].typeData)">
                  <span v-if="i.type=='1'" class="go-link link-prevent" @click="goTopage()">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span v-if="i.type=='2'" class="go-link" @click="compareDate(item.Listingdate)?'':intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">
                    <span :class="compareDate(item.Listingdate)?'forward-datetext':''">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  </span>
                  <span v-if="(item.Startdate.length>6&&item.Enddate.length>6)&&(i.type=='1')" class="date-text12">认购期限：{{item.Startdate}}至{{item.Enddate}}</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="XGFXGGTotal>10" @click="handelMore(1)">查看更多</li>
          </ul>
        </li>
        <li class="li-container" v-if="(XGFXARR.MGData.SSData.length>0)">
          <p class="title">美股新股</p>
          <ul class="sub-ul ggxg">
            <li class="sub-li">
              <p class="sub-title">今日上市：</p>
              <ul>
                <li v-for="(item,index) in getTenData(XGFXARR.MGData.SSData)">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="XGFXMGTotal>10" @click="handelMore(1)">查看更多</li>
          </ul>
        </li>
        <li class="li-container" v-if="getItemLen(CBPLARR.GGData)>0">
          <p class="title title-purple">港股财报</p>
          <ul class="sub-ul ggxg">
            <li v-if="CBPLARR.GGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in CBPLARR.GGData">
              <p class="sub-title">{{i.type}}：</p>
              <ul>
                <li v-for="(item,index) in getTenData(CBPLARR.GGData[j].typeData)">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span class="date-text12"><span v-if="item.Startdate.length>6&&item.Enddate.length>6">{{item.Startdate}}至{{item.Enddate}}</span></span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="CBPLGGTotal>10" @click="handelMore(2)">查看更多</li>
          </ul>
        </li>
        <li class="li-container" v-if="getItemLen(CBPLARR.MGData)>0">
          <p class="title">美股财报</p>
          <ul class="sub-ul ggxg">
            <li v-if="CBPLARR.MGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in (CBPLARR.MGData)">
              <p class="sub-title">{{i.type}}：</p>
              <ul>
                <li v-for="(item,index) in getTenData(CBPLARR.MGData[j].typeData)">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span v-if="item.Startdate.length>6&&item.Enddate.length>6" class="date-text12">{{item.Startdate}}至{{item.Enddate}}</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="CBPLMGTotal>10" @click="handelMore(2)">查看更多</li>
          </ul>
        </li>
        <li class="li-container" v-if="(CQQXARR.GGData.length>0)">
            <p class="title title-purple">港股分红派息</p>
            <ul class="sub-ul ggxg">
              <li class="sub-li">
                <ul>
                  <li v-for="(item,index) in getTenData(CQQXARR.GGData)">
                    <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                    <span class="date-text13block">每股派息: {{item.Cashamount}}({{item.Cashcurrency}})</span>
                  </li>
                  <li v-if="CQQXGGTotal>10" @click="handelMore(3)">查看更多</li>
                </ul>
              </li>
            </ul>
        </li>
        <li class="li-container" v-if="(CQQXARR.MGData.length>0)">
            <p class="title">美股分红派息</p>
            <ul class="sub-ul ggxg">
              <li class="sub-li">
                <ul>
                  <li v-for="(item,index) in getTenData(CQQXARR.MGData)" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">
                    <span class="go-link">{{item.Securityshortname}}({{item.Securitycode}})</span>
                    <span class="date-text13block">每股派息: {{item.Cashamount}}(USD)</span>
                  </li>
                  <li v-if="CQQXMGTotal>10" @click="handelMore(3)">查看更多</li>
                </ul>
              </li>
            </ul>
        </li>
        <li class="no-container" v-show="(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)&&(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)&&(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3">
          <i></i>
          <p class="text">暂无数据</p>
        </li>
      </ul>
      <ul :class="['ul-container',(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)?'nodata-container':'']" v-show="activedIndex==1">
        <li class="li-container" v-if="getItemLen(XGFXARR.GGData)>0">
          <p class="title title-purple">港股新股</p>
          <ul class="sub-ul ggxg">
            <li v-if="XGFXARR.GGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in XGFXARR.GGData">
              <p class="sub-title">{{i.type=='1'?"认购中：":"今日上市："}}</p>
              <ul>
                <li v-for="(item,index) in XGFXARR.GGData[j].typeData">
                  <span v-if="i.type=='1'" class="go-link link-prevent" @click="goTopage()">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span v-if="i.type=='2'" class="go-link" @click="compareDate(item.Listingdate)?'':intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">
                    <span :class="compareDate(item.Listingdate)?'forward-datetext':''">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  </span>
                  <span v-if="(item.Startdate.length>6&&item.Enddate.length>6)&&(i.type=='1')" class="date-text12">认购期限：{{item.Startdate}}至{{item.Enddate}}</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="getItemLen(XGFXARR.GGData)>9 && XGFXGGMore" @click="loadMore('1')">查看更多</li>
            <li class="sub-li nomore-data" v-if="!XGFXGGMore">暂无更多数据</li>
          </ul>
        </li>
        <li class="li-container" v-if="(XGFXARR.MGData.SSData.length>0)">
          <p class="title">美股新股</p>
          <ul class="sub-ul ggxg">
            <li class="sub-li">
              <p class="sub-title">今日上市：</p>
              <ul>
                <li v-for="(item,index) in XGFXARR.MGData.SSData">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                </li>
                <li v-if="XGFXARR.MGData.SSData.length>9 && XGFXMGMore" @click="loadMore('2')">查看更多</li>
                <li class="nomore-data nomore-data" v-if="!XGFXMGMore">暂无更多数据</li>
              </ul>
            </li>
          </ul>
        </li>
        <li class="no-container" v-show="(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)">
          <i></i>
          <p class="text">暂无数据</p>
        </li>
      </ul>
      <ul :class="['ul-container',(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)?'nodata-container':'']" v-show="activedIndex==2">
        <li class="li-container" v-if="getItemLen(CBPLARR.GGData)>0">
          <p class="title title-purple">港股财报</p>
          <ul class="sub-ul ggxg">
            <li v-if="CBPLARR.GGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in CBPLARR.GGData">
              <p class="sub-title">{{i.type}}：</p>
              <ul>
                <li v-for="(item,index) in CBPLARR.GGData[j].typeData">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span class="date-text12"><span v-if="item.Startdate.length>6&&item.Enddate.length>6">{{item.Startdate}}至{{item.Enddate}}</span></span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="getItemLen(CBPLARR.GGData)>9 && CBPLGGMore" @click="loadMore('3')">查看更多</li>
            <li class="sub-li nomore-data" v-if="!CBPLGGMore">暂无更多数据</li>
          </ul>
        </li>
        <li class="li-container" v-if="getItemLen(CBPLARR.MGData)>0">
          <p class="title">美股财报</p>
          <ul class="sub-ul ggxg">
            <li v-if="CBPLARR.MGData[j].typeData.length>0" class="sub-li" v-for="(i , j) in (CBPLARR.MGData)">
              <p class="sub-title">{{i.type}}：</p>
              <ul>
                <li v-for="(item,index) in CBPLARR.MGData[j].typeData">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span v-if="item.Startdate.length>6&&item.Enddate.length>6" class="date-text12">{{item.Startdate}}至{{item.Enddate}}</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="getItemLen(CBPLARR.MGData)>9 && CBPLMGMore" @click="loadMore('4')">查看更多</li>
            <li class="sub-li nomore-data" v-if="!CBPLMGMore">暂无更多数据</li>
          </ul>
        </li>
        <li class="no-container" v-show="(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)">
          <i></i>
          <p class="text">暂无数据</p>
        </li>
      </ul>
      <ul :class="['ul-container',(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3?'nodata-container':'']" v-show="activedIndex==3">
        <li class="li-container" v-if="(CQQXARR.GGData.length>0)">
          <p class="title title-purple">港股分红派息</p>
          <ul class="sub-ul ggxg">
            <li class="sub-li">
              <ul>
                <li v-for="(item,index) in CQQXARR.GGData">
                  <span class="go-link" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span class="date-text13block">每股派息: {{item.Cashamount}}({{item.Cashcurrency}})</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="CQQXARR.GGData.length>9 && CQQXGGMore" @click="loadMore('5')">查看更多</li>
            <li class="sub-li nomore-data" v-if="!CQQXGGMore">暂无更多数据</li>
          </ul>
        </li>
        <li class="li-container" v-if="(CQQXARR.MGData.length>0)">
          <p class="title">美股分红派息</p>
          <ul class="sub-ul ggxg">
            <li class="sub-li">
              <ul>
                <li v-for="(item,index) in CQQXARR.MGData" @click="intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)">
                  <span class="go-link">{{item.Securityshortname}}({{item.Securitycode}})</span>
                  <span class="date-text13block">每股派息: {{item.Cashamount}}(USD)</span>
                </li>
              </ul>
            </li>
            <li class="sub-li more-data" v-if="CQQXARR.MGData.length>9 && CQQXMGMore" @click="loadMore('6')">查看更多</li>
            <li class="sub-li nomore-data" v-if="!CQQXMGMore">暂无更多数据</li>
          </ul>
        </li>
        <li class="no-container" v-show="(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3">
          <i></i>
          <p class="text">暂无数据</p>
        </li>
      </ul>
    </financeTab>
  </div>
</template>
<script>
import financePicker from './financePickerNew'
import financeTab from './financeTab'
 //require('emf/src/js/util/util-nativepi');
const util = require('@/utils/tool.js')
const todayDate = new Date(),todayYear = todayDate.getFullYear(),todayMonth = todayDate.getMonth() + 1,todayDay=todayDate.getDate();
export default {
  name: 'finance-view',
  data () {
    return {
      activedIndex:0,
      tabItem:['全部','新股发行','财报披露','分红派息'],
      curDate:null,
      XGFXARR:{
        GGData:[
          { type:'1',typeData:[] },
          { type:'2',typeData:[] }
        ],
        MGData:{
          SSData:[],
        }
      },
      XGFXGGTotal:0,
      XGFXMGTotal:0,
      CBPLGGTotal:0,
      CBPLMGTotal:0,
      CQQXGGTotal:0,
      CQQXMGTotal:0,
      CBPLARR:{
        GGData:[
          { type:'三季度报告',typeData:[] },
          { type:'半年度报告',typeData:[] },
          { type:'年度报告',typeData:[] },
          { type:'一季度报告',typeData:[] }
        ],
        MGData:[
          { type:'开市前',typeData:[] },
          { type:'收市后',typeData:[] },
          { type:'财报披露',typeData:[] }
        ]
      },
      CQQXARR:{
        GGData:[],
        MGData:[]
      },
      XGFXGGPage:1,XGFXGGMore:true,XGFXMGPage:1,XGFXMGMore:true,tabisLoad1:false,
      CBPLGGPage:1,CBPLGGMore:true,CBPLMGPage:1,CBPLMGMore:true,tabisLoad2:false,
      CQQXGGPage:1,CQQXGGMore:true,CQQXMGPage:1,CQQXMGMore:true,tabisLoad3:false,
      isLoading:true
    }
  },
  components:{
    financePicker:financePicker,
    financeTab:financeTab
  },
  methods:{
    formatUint(num){

    },
    goTopage(){
      window.sessionStorage.setItem("curDate",this.curDate);
      //window.location = 'https://hktrade.eastmoney.com/Share/IPO/Index';
	    //window.location = this.shareIPOUrl();
    },
    shareIPOUrl(){
      let IPOUrl = '';
      if (location.protocol.indexOf('http') < 0) {
        IPOUrl = 'https://hktrade.eastmoney.com/Share/IPO/Index'
      }
      else {
        IPOUrl = 'http://10.10.81.131/Share/IPO/Index'
      }
      return IPOUrl;
    },
    getTenData(arr){
      if(arr.length>10){
        return arr.slice(0,10);
      }
      return arr;
    },
    compareDate(curDate){
      var num1=parseInt(curDate.toString().split("-").join(""));
      var num2=parseInt([todayYear,util.numLessTen(todayMonth),util.numLessTen(todayDay)].join(""));
      return num1>num2;
    },
    getItemLen(array){
      var count=0;
      for (let index = 0; index < array.length; index++) {
        count+=array[index].typeData.length;
      }
      return count;
    },
    handelMore(flag){
      this.$refs.childTab.handelSwitch(flag);
      window.scrollTo(0, 0);
    },
    loadMore(flag){
      switch (flag) {
        case '1':
          if(!this.XGFXGGMore){
            return ;
          }
          this.getData(++this.XGFXGGPage,10,this.curDate,flag,1);
          break;
        case '2':
          if(!this.XGFXMGMore){
            return ;
          }
          this.getData(++this.XGFXMGPage,10,this.curDate,flag,1);
          break;
        case '3':
          if(!this.CBPLGGMore){
            return ;
          }
          this.getData(++this.CBPLGGPage,10,this.curDate,flag,1);
          break;
        case '4':
          if(!this.CBPLMGMore){
            return ;
          }
          this.getData(++this.CBPLMGPage,10,this.curDate,flag,1);
          break;
        case '5':
          if(!this.CQQXGGMore){
            return ;
          }
          this.getData(++this.CQQXGGPage,10,this.curDate,flag,1);
          break;
        case '6':
          if(!this.CQQXMGMore){
            return ;
          }
          this.getData(++this.CQQXMGMore,10,this.curDate,flag,1);
          break;
        default:
      }
    },
    getData(num,size,dateTime,typeStr,flag){
      if(flag==0){
        num=1;
      }
      var that = this;
      var time=new Date(dateTime);
      var timestr=time.getFullYear()+"-"+(time.getMonth()+1)+"-"+time.getDate();
      debugger
      this.$http('CJRL/GetEconomicCalendar',{pageSize:size,pageNum:num,dateTime:timestr,typeStr: typeStr },'post').then(function(res) {
        that.isLoading=false;
        if(res.data.Status == 0){
          switch (typeStr) {
            case '1':
              that.tabisLoad1=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.XGFXGGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.XGFXGGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                for (let i = 0; i < that.XGFXARR.GGData.length; i++) {
                  if(that.XGFXARR.GGData[i].type==item.TYPE){
                    if(((item.TYPE=='1')&&(item.Startdate.length>6 && item.Enddate.length>6))||(item.TYPE=='2')){
                      that.XGFXARR.GGData[i].typeData.push(item);
                    }
                    continue;
                  }
                }
              });
              break;
            case '2':
              that.tabisLoad1=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.XGFXMGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.XGFXMGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                  that.XGFXARR.MGData.SSData.push(item);
              });
              break;
            case '3':
              that.tabisLoad2=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.CBPLGGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.CBPLGGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                for (let i = 0; i < that.CBPLARR.GGData.length; i++) {
                  if(that.CBPLARR.GGData[i].type==item.Sourcetype){
                    that.CBPLARR.GGData[i].typeData.push(item);
                    continue;
                  }
                }
              });
              break;
            case '4':
              that.tabisLoad2=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.CBPLMGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.CBPLMGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                if((item.Timetype=="--")||(!item.Timetype)){
                  that.CBPLARR.MGData[2].typeData.push(item);
                }
                else{
                  for (let i = 0; i < that.CBPLARR.MGData.length; i++) {
                    // var tempType=item.TYPE=='1'? item.Timetype : item.Sourcetype ;
                    if(that.CBPLARR.MGData[i].type==item.Timetype){
                      that.CBPLARR.MGData[i].typeData.push(item);
                      continue;
                    }
                  }
                }
              });
              break;
            case '5':
              that.tabisLoad3=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.CQQXGGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.CQQXGGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                that.CQQXARR.GGData.push(item);
              });
              break;
            case '6':
              that.tabisLoad3=true;
              if(res.data.Result.EconomicCalendarList.length>0){
                that.CQQXMGTotal=res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if(res.data.Result.EconomicCalendarList.length<10 && (flag==1)){
                that.CQQXMGMore=false;
              }
              res.data.Result.EconomicCalendarList.map(item => {
                that.CQQXARR.MGData.push(item);
              });
              break;
            default:
          }
        }
      });
    },
    handelClick(index){
      this.activedIndex=index;
    },
    transferDate(date){
      window.sessionStorage.removeItem("curDate");
      this.tabisLoad1=false;this.tabisLoad2=false;this.tabisLoad3=false;
      this.isLoading=true;
      this.curDate=date;
      for (var i = 0; i < this.XGFXARR.GGData.length; i++) {
        this.XGFXARR.GGData[i].typeData=[];
      }
      this.XGFXARR.MGData.SSData=[];
      for (var i = 0; i < this.CBPLARR.GGData.length; i++) {
        this.CBPLARR.GGData[i].typeData=[];
      }
      for (var i = 0; i < this.CBPLARR.MGData.length; i++) {
        this.CBPLARR.MGData[i].typeData=[];
      }
      this.CQQXARR.GGData=[];
      this.CQQXARR.MGData=[];
      this.XGFXGGPage=1;
      this.XGFXGGMore=true;
      this.XGFXMGPage=1;
      this.XGFXMGMore=true;
      this.CBPLGGPage=1;
      this.CBPLGGMore=true;
      this.CBPLMGPage=1;
      this.CBPLMGMore=true;
      this.CQQXGGPage=1;
      this.CQQXGGMore=true;
      this.CQQXMGPage=1;
      this.CQQXMGMore=true;
      this.getData(1,10,date,'1',0);
      this.getData(1,10,date,'2',0);
      this.getData(1,10,date,'3',0);
      this.getData(1,10,date,'4',0);
      this.getData(1,10,date,'5',0);
      this.getData(1,10,date,'6',0);
    },
    intoStockNativePage(stockName,stockCode, marketCode){ //NYSE:纽约证券交易所  NASDAQ:纳斯达克证券市场  AMEX:美国证券交易所  HK:港交所
      window.sessionStorage.setItem("curDate",this.curDate);
      if (AG.InApp) {
     		var jsonStr ='{"stockName": "' + stockName + '","stockCode": "' + marketCode +'|'+stockCode + '"}';
     		if (AG.ISIOS) {
     		  window.location = "emH5ToNativePage:" + jsonStr;
     		}else {
     		  eastmoney.emH5ToNativePage(jsonStr);
     		}
   	  }
   	  else {
        //分时地址
        if(marketCode == "NYSE" || marketCode == "NASDAQ" || marketCode == "AMEX")
        {
          location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "7.html";
        }
        else if(marketCode == "HK" ){
          location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "5.html";
        }
   	  }
    }
  },
  created(){
    var tempDate=window.sessionStorage.getItem("curDate");
    if(tempDate){
      this.curDate=tempDate;
    }else{
      this.curDate=[todayYear,util.numLessTen(todayMonth),util.numLessTen(todayDay)].join("-");
    }
    this.getData(1,10,this.curDate,'1',0);
    this.getData(1,10,this.curDate,'2',0);
    this.getData(1,10,this.curDate,'3',0);
    this.getData(1,10,this.curDate,'4',0);
    this.getData(1,10,this.curDate,'5',0);
    this.getData(1,10,this.curDate,'6',0);
  },
  mounted(){
    if(navigator.userAgent.toLocaleLowerCase().indexOf('color=b')>-1 || location.search.indexOf('color=b')>-1
	|| navigator.userAgent.toLocaleLowerCase().indexOf('color=d')>-1 || location.search.indexOf('color=d')>-1){
  		document.documentElement.getElementsByTagName('body')[0].className = '';
  	}
    if(navigator.userAgent.toLocaleLowerCase().indexOf('color=o')>-1 || location.search.indexOf('color=o')>-1){
  		document.documentElement.getElementsByTagName('body')[0].className = 'orange-skin';
  	}
    util.shareFun(
      "港美财经日历",
      "港美财经日历-东方财富",
      "东方财富港美财经日历，提供未来最新新股申购上市动向、财报披露状态、分红派息日期等消息。",
      location.href
    );
  }
}
</script>



// WEBPACK FOOTER //
// src/components/financeCalendar/financeView.vue